export const Compare = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9583 7.41667V9.29167M10.9583 9.29167V11.1667M10.9583 9.29167H9.08333M10.9583 9.29167H12.8333M10.6888 3.77605C9.8633 1.98958 8.05558 0.75 5.95833 0.75C3.08185 0.75 0.75 3.08185 0.75 5.95833C0.75 8.78845 3.00728 11.0913 5.81966 11.1649M16.1667 9.29167C16.1667 12.1681 13.8348 14.5 10.9583 14.5C8.74215 14.5 6.84926 13.1158 6.09701 11.1649C5.87287 10.5836 5.75 9.95197 5.75 9.29167C5.75 6.46155 8.00728 4.15865 10.8197 4.08514C10.8657 4.08394 10.912 4.08333 10.9583 4.08333C13.8348 4.08333 16.1667 6.41518 16.1667 9.29167Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Compare
